import IconTick from 'approot/shared/icons/icon-tick';
import * as Styled from './richtext-toolbar.style';

type Props = {
  isSelected: boolean;
  text: string;
  onChange?: () => void;
  fontSize?: number;
  fontFamily?: string;
  lineHeight?: number;
  fontWeight?: number;
  colour?: string;
};

const RichtextToolbarDropdownItem = ({
  isSelected,
  text,
  fontSize,
  fontWeight,
  fontFamily,
  lineHeight,
  colour,
  onChange,
}: Props) => {
  return (
    <Styled.RichtextDropdownItem
      onClick={onChange}
      $fontSize={fontSize}
      $fontWeight={fontWeight}
      $fontFamily={fontFamily}
      $lineHeight={lineHeight}
      $colour={colour}
      $isActive={isSelected}
      data-dropdown-item={true}
      role="option"
    >
      <Styled.RichtextDropdownItemTick>
        {isSelected && <IconTick width={10} />}
      </Styled.RichtextDropdownItemTick>

      {text}
    </Styled.RichtextDropdownItem>
  );
};

export default RichtextToolbarDropdownItem;
